import React, { useState, useEffect } from "react";
import { StyledSection6 } from "./style";
import { API } from "../../../apis/dashboard.api";
import { CardSection } from "../../../components/CardSection";
import { BarGraph } from "../../../components/Graph/BarGraph";

export const Section6 = () => {
  const [statisticData, setStatisticData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await API.getDailyReceiveCount();
        if (result) {
          setStatisticData(result);
        }
      } catch (error) {
        console.error("오류 발생:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <StyledSection6>
      <div className="section6-container">
        <span className="line">
          <p className="title">당일 데이터</p>
        </span>
        <CardSection title="당일 데이터 수신 현황" icon="Histogram">
          <BarGraph
            data={statisticData}
            xKey="departmentName"
            yKey={[{ label: "수신된 데이터 개수", key: "receivedDataCnt" }]}
            tickFormmatter={(value) => value.replace("국토관리사무소", "")}
            yLabel="개수"
            unit="개"
            showLabels={true}
          />
        </CardSection>
      </div>
    </StyledSection6>
  );
};
